function Home() {
  return <div className="main-wrapper">
    
    

    <h2>Herzlich willkommen zu meinen Tanzangeboten!</h2>

    <p>
      Hier finden Sie Gruppen mit Freiem Kreativem Tanz und Heilsamer Bewegung.
    </p>

    <p>
      Es handelt sich ausdrücklich nicht um Therapie, auch wenn Elemente aus der Holistischen Tanz- und Bewegungstherapie einfließen können.
    </p>


  </div>;
}
export default Home;